// The "F — do this here" chip that appears when you stand at a Capital landmark with something to do.
import { Events, on } from './eventBus.js'
import { actionAt } from '../game/capitalDeals.js'
import { DealConfig } from '../config/capital.js'

let el = null, current = null, flashUntil = 0

export function mountCapitalDealsUI() {
  el = document.createElement('div')
  el.className = 'cap-deal'
  el.setAttribute('role', 'status')
  document.body.appendChild(el)
  el.addEventListener('click', () => perform())
  document.addEventListener('keydown', (e) => {
    if ((e.key === 'f' || e.key === 'F') && current && document.body.classList.contains('in-capital')) perform()
  })
}

function perform() {
  if (!current) return
  const msg = current.run()
  flashUntil = Date.now() + 4500
  el.innerHTML = `<span class="cap-deal__msg">${msg}</span>`
  el.classList.add('on')
}

// Called every frame from the scene with the hero's position in source metres and the landmark list.
export function updateCapitalDealsUI(hx, hz, pois) {
  if (!el) return
  if (Date.now() < flashUntil) return
  let best = null, bd = DealConfig.reach
  for (const p of pois ?? []) {
    const d = Math.hypot(hx - p.x, hz - p.z)
    if (d <= bd) { best = p; bd = d }
  }
  const a = actionAt(best)
  current = a
  if (!a) { el.classList.remove('on'); return }
  el.classList.add('on')
  const html = `<kbd>F</kbd><span><b>${a.label}</b><i>${a.note}</i></span>`
  if (el.dataset.k !== html) { el.dataset.k = html; el.innerHTML = html }
}

export function hideCapitalDealsUI() { current = null; flashUntil = 0; el?.classList.remove('on'); if (el) el.dataset.k = '' }
